/**
 * jQuery Storage Plugin + custom API for use in panama UI
 */

mmf_modules.define('utils/storage',[
    'jquery',
    'plugins/storage'
], function (
    $,
    storage_is_jq_plugin
) {
    'use strict';

    // For Saving various profile settings
    // Dependency - Storage (below)
    var Storage = {
        Set: function (key, value) {
            $.totalStorage(key, value);
            return 'Key Set: ' + key;
        },

        Get: function (key, default_value) {
            var value = $.totalStorage(key);
            if (!value) {
                value = default_value;
            }
            return value;
        },

        Delete: function (key) {
            $.totalStorage.deleteItem(key);
            return 'Key Deleted: ' + key;
        }
    };

    return Storage;
});
